export type ChatNotesErrorCode =
  'INVALID_CONFIGURATION' |
  'NETWORK_ERROR' |
  'TIMEOUT' |
  'HTTP_ERROR' |
  'INVALID_RESPONSE' |
  'INCOMPATIBLE_PROTOCOL' |
  'SESSION_REQUIRED';

interface ChatNotesErrorDetails {
  cause?: unknown;
  requestId?: string;
  serverCode?: string;
  status?: number;
}

export class ChatNotesError extends Error {
  public readonly code: ChatNotesErrorCode;
  public readonly requestId?: string;
  public readonly serverCode?: string;
  public readonly status?: number;

  constructor(code: ChatNotesErrorCode, message: string, details: ChatNotesErrorDetails = {}) {
    super(message);
    this.name = 'ChatNotesError';
    this.code = code;
    this.requestId = details.requestId;
    this.serverCode = details.serverCode;
    this.status = details.status;

    if(details.cause !== undefined) {
      Object.defineProperty(this, 'cause', {
        configurable: true,
        value: details.cause
      });
    }
  }
}
